module.exports = __webpack_public_path__ + "static/media/practice-question-divider.fd43c4e2.png";